import React from "react";
import { Slider } from "antd";
import { useAppSelector, useAppDispatch } from "../store/hooks";
import { selectScale, setScale } from "../store/slices/configurationSlice";

const markers = {
  0.25: "25%",
  0.5: "50%",
  1.0: "100%",
  1.5: "150%",
};

export const ScaleSlider: React.FC = () => {
  const dispatch = useAppDispatch();
  const scale = useAppSelector(selectScale);
  
  return (
    <Slider
      marks={markers}
      step={0.05}
      min={0.25}
      max={1.5}
      value={scale}
      onChange={(val) => dispatch(setScale(val))}
      tooltip={{ open: false }}
    />
  );
};
